import { responseStatus, useHandleRequest } from "../service/api-services";
import { getDefaultQuery } from "../utils/query-client";

export const systemTypesQueries = {
    EDIT: "SYSTEMTYPES_EDIT",
    CREATE: "SYSTEMTYPES_CREATE",
    DELETE: "SYSTEMTYPES_DELETE",
    GET_ALL: "SYSTEMTYPES_GET_ALL",
    GET_ALL_OPTIONS: "SYSTEMTYPES_GET_ALL_OPTIONS",
    GET_BY_ID: "SYSTEMTYPES_GET_BY_ID",
}


export function useSystemTypesService() {

    const handleRequest = useHandleRequest();

    async function creatSystemTypes({ payload, onSuccess }) {
        const { status, data } = await handleRequest.handleRequest(`/system-types/${payload.id}`, 'POST');
        if (status === responseStatus.SUCCESS) {
            if (onSuccess) {
                onSuccess(data);
            }
        }
    }

    async function editSystemTypes({ payload, onSuccess }) {
        const { status, data } = await handleRequest.handleRequest(`/system-types/${payload.id}`, 'PUT', payload);
        if (status === responseStatus.SUCCESS) {
            if (onSuccess) {
                onSuccess(data);
            }
        }
    }

    async function deletSystemTypes({ id, onSuccess }) {
        const { status, data } = await handleRequest.handleRequest(`/system-types/${id}`, 'DELETE');
        if (status === responseStatus.SUCCESS) {
            if (onSuccess) {
                onSuccess(data);
            }
        }
    }

    async function getAllSystemTypes({ search, page }) {
        const filters = [{ search }];
        let query = getDefaultQuery({ page, filters });
        const { status, data } = await handleRequest.handleRequest(`/system-types/${query}`, 'GET');
        if (status === responseStatus.SUCCESS) {
            return data;
        }
    }

    async function getAllSystemTypesOptions({ search, page }) {
        const filters = [{ search }];
        let query = getDefaultQuery({ page, filters });
        const { status, data } = await handleRequest.handleRequest(`/system-types/${query}`, 'GET');
        if (status === responseStatus.SUCCESS) {
            return data.rows.map(data=>({key: data.id, value: data.name}));
        }
    }

    async function getSystemTypesById({ id }) {
        if (id) {
            const { status, data } = await handleRequest.handleRequest(`/system-types/${id}`, 'GET');
            if (status === responseStatus.SUCCESS) {
                return data;
            }
        }
    }

    return {
        creatSystemTypes,
        editSystemTypes,
        deletSystemTypes,
        getAllSystemTypes,
        getSystemTypesById,
        getAllSystemTypesOptions
    }
}
